import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import manifestJson from '../../manifest.json';
const saveLastSeen = () => {
    LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.LAST_VERSION_UPDATE, manifestJson.version);
    LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.LAST_NAME_UPDATE, manifestJson.name);
    LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.LAST_DESCRIPTION_UPDATE, manifestJson.description);
};
export const WhatsNewUtils = {
    saveLastSeen,
};
